import React from "react";
import s from "./chart-info.module.scss";

const ChartInfo = (props) => {
    return (
        <div className={s.ChartInfo}>
            {props.getValue(props.body+'_CHART_INFO')}
        </div>
    )
}

export default ChartInfo;